import {Component} from '@angular/core';

@Component({
  selector: 'app-krdya-logo',
  templateUrl: './krdya-logo.component.html'
})
export class KrdYaLogoComponent {
}
